/**
 * ч.1075: назва акаунта (клієнта) для показу — власний ярлик користувача,
 * якщо його задано («Обліковий запис» → «Мої доступи»), інакше назва.
 */
export function tenantDisplayName(t: { name: string; label?: string | null }): string {
  return t.label?.trim() || t.name;
}
